import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    seancesLoaded: { type: Boolean, default: false },
    archiveLoaded: { type: Boolean, default: false },
    equipmentLoaded: { type: Boolean, default: false },
    reportsLoaded: { type: Boolean, default: false },
    auditLoaded: { type: Boolean, default: false },
    stationId: Number,
    equipmentId: Number
  };

  static targets = ['archiveTypeTab', 'seancesResultContainer', 'equipmentTabContainer', 'reportsResultContainer', 'auditResultContainer'];

  loadSeances() {
    if(this.stationIdValue && !this.seancesLoadedValue){
      const url = `/stations/${this.stationIdValue}/seances`;
      fetch(url)
        .then(response => response.text())
        .then(html => {
          this.seancesResultContainerTarget.innerHTML = html;
          this.seancesLoadedValue = true;
        });
    }
  }

  loadEquipment() {
    if (this.equipmentLoadedValue) return;

    const url = `/stations/${this.stationIdValue}/equipment/${this.equipmentIdValue}`
    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' } })
      .then(response => response.text())
      .then(html => {
        this.equipmentTabContainerTarget.innerHTML = html;
        if (window.feather) window.feather.replace({ width: 14, height: 14 });
        this.equipmentLoadedValue = true;
      });
  }

  selectFirstArchiveTab() {
    if (this.hasArchiveTypeTabTarget && !this.archiveLoadedValue){
      this.archiveTypeTabTarget.click();
      this.archiveLoadedValue = true;
    }
  }

  loadReports() {
    if(this.stationIdValue && !this.reportsLoadedValue){
      const url = `/stations/${this.stationIdValue}/user_reports`;
      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' } })
        .then(response => response.text())
        .then(html => {
          this.reportsResultContainerTarget.innerHTML = html;
          this.reportsLoadedValue = true;
          flatpickr('.flatpickr-report', {
            enableTime: true,
            dateFormat: "d.m.Y H:i",
            defaultHour: '10'
          });
        });
    }
  }

  loadAudit(event) {
    let perPage = 10
    let auditableType = ''
    let action = ''
    let auditableId = ''
    let remoteAddress = ''
    let createdAt = ''
    let page = 1

    if (this.auditLoadedValue) {
      perPage = document.querySelector('select[name="per_page"]').value;
      auditableType = document.querySelector('input[name="q[auditable_type_cont]"').value;
      action = document.querySelector('select[name="q[action_cont]"').value;
      auditableId = document.querySelector('input[name="q[auditable_id_eq]"').value;
      remoteAddress = document.querySelector('input[name="q[remote_address_cont]"').value;
      createdAt = document.querySelector('input[name="q[created_at_belongs_to_day]"').value;
      page = event.target.innerText;
    }
    const url = `/custom_audits?custom_audit[station_id]=${this.stationIdValue}&q[auditable_type_cont]=${auditableType}&q[action_cont]=${action}&q[auditable_id_eq]=${auditableId}&q[remote_address_cont]=${remoteAddress}&q[created_at_belongs_to_day]=${createdAt}&per_page=${perPage}&page=${page}`
    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }})
      .then(response => response.text())
      .then(html => {
        this.auditResultContainerTarget.innerHTML = html;
        if (window.feather) window.feather.replace({ width: 14, height: 14 });
        this.auditLoadedValue = true;
        flatpickr('#q_created_at_belongs_to_day', {
          dateFormat: 'd.m.Y'
        });
        const paginateElements = document.querySelectorAll('.page-link');
        if (paginateElements) {
					paginateElements.forEach((paginateItem) => {
            paginateItem.removeAttribute('href');
						paginateItem.setAttribute('data-action', 'click->stations--show#loadAudit');
					});
				}
      });
  }

  resetAuditFilter() {
    const url = `/custom_audits?custom_audit[station_id]=${this.stationIdValue}&cancel_filter=true`;
    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' } })
      .then(response => response.text())
      .then(html => {
        this.auditResultContainerTarget.innerHTML = html;
        if (window.feather) window.feather.replace({ width: 14, height: 14 });
        this.auditLoadedValue = true;
        flatpickr('#q_created_at_belongs_to_day', {
          dateFormat: 'd.m.Y'
        });
      });
  }
}
